import { useTranslation } from 'react-i18next';

import styles from './address.modal.module.css';
import { Dialog } from '@radix-ui/themes';
import LocationSearchComponent from '../ui/location-search';

import { hideGlobalModal } from '@app/utils/modals';

export default function AddressModalComponent() {
    const { t } = useTranslation();

    return (
        <Dialog.Root open={true} onOpenChange={(open) => { if (!open) hideGlobalModal('address'); }}>
            <Dialog.Content maxWidth="480px" className={styles.root} data-test="address-modal">
                <div className={`${styles.modalHeader} bg_gray text-center w-100 py-3 m-0`}>
                    <Dialog.Title size="4" className="m-0">{t('Потърси по адрес')}</Dialog.Title>
                </div>
                <div className={styles.content}>
                    <div className={styles.description}>{t('PICK_ADDRESS_DESCRIPTION')}</div>

                    <LocationSearchComponent onSubmit={() => hideGlobalModal('address')} />

                    <Dialog.Close>
                        <button
                            title="Close (Esc)"
                            type="button"
                            className={styles.closeButton}
                            onClick={() => hideGlobalModal('address')}></button>
                    </Dialog.Close>
                </div>
            </Dialog.Content>
        </Dialog.Root>
    );
}